import advancedToolbar from 'emun.on-demand/toolbars/designer-toolbar.advanced.htm'
import globalToolbar from 'emun.on-demand/toolbars/designer-toolbar.global.htm'
import mobileToolbar from 'emun.on-demand/toolbars/designer-toolbar.mobile.htm'
import simpleToolbar from 'emun.on-demand/toolbars/designer-toolbar.simple.htm'
import inlineToolbar from 'emun.on-demand/toolbars/designer-toolbar.inline.htm'
import designInfoToolbar from 'emun.on-demand/toolbars/designer-toolbar.design-info.htm'
import DesignerToolbarController from 'emun.on-demand/toolbars/designer-toolbar.controller'

let DesignerToolbar = {
    bindings: {
        designer: '<ngModel',
        product: '<?',
        hidePerspectives: '@',
        hideUndoRedo: '@',
        hideReset: '@',
        hideSettings: '@',
        showRatioPicker: '@'
    },
    controller: DesignerToolbarController,
    templateUrl($element, $attrs) {
        if ($attrs.templateUrl) return $attrs.templateUrl;
        else if ($attrs.type === 'advanced') return advancedToolbar;
        else if ($attrs.type === 'mobile') return mobileToolbar;
        else if ($attrs.type === 'global') return globalToolbar;
        else if ($attrs.type === 'info') return designInfoToolbar;
        else if ($attrs.type === 'inline') return inlineToolbar;
        else if ($attrs.type === 'design-info') return designInfoToolbar;
        else return simpleToolbar;
    }
}

export default DesignerToolbar;